import { defineStore } from 'pinia';
import { GET_SYSTEMCONFIG, GET_BANNER, GET_SHARE } from '@/api';
import { hasData } from "@/utils";


const state = () => ({
  _shareURL: "",
  _systemConfig: {},
  _banner: [],
})

export const useSystemStore = defineStore('system', {
  state,
  getters: {
    banners() {
      if (!hasData(this._banner)) {
        this.getBanner();
      }
      return this._banner;
    },
    shareURL() {
      return this._shareURL;
    },
    systemConfig() {
      if (!hasData(this._systemConfig)) {
        this.getSystemConfig();
      }
      return this._systemConfig;
    },
  },
  actions: {
    async getSystemConfig(other = {}) {
      try {
        const { data } = await GET_SYSTEMCONFIG();
        this._systemConfig = { ...(data || {}) };
        if (other?.kefu) {
          data.service_url && window.open(data.service_url);
        }
      } catch (error) {
        console.error("获取系统配置错误", error)
      }
    },
    async getBanner() {
      try {
        const { data } = await GET_BANNER();
        this._banner = [...(data || [])];
      } catch (error) {
        console.error("获取banner错误", error)
      }
    },
    async getShareUrl() {
      try {
        const { data } = await GET_SHARE();
        this._shareURL = data.text || "";
      } catch (error) { }
    },
  }
})